import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';

const SpotSelectV2 = lazy(() => import('@frontend/spot/select').then((module) => ({ default: module.SpotSelectV2 })));

export interface SpotFieldProps {
    onChange: (value: string | null) => void;
    value: string | null;
    disabled?: boolean;
    className?: string;
    label?: React.ReactNode;
    required?: boolean;
    options?: string[];
}

export const SpotField = (props: SpotFieldProps) => {
    return (
        <AsyncComponent>
            <SpotSelectV2
                {...props}
                label={props.label || 'SPOT'}
                isClearable
            />
        </AsyncComponent>
    );
};
